import React, { useEffect, useRef, useState } from 'react';

import ModalContainer from '@components/modals/ModalContainer';

import { fetchPomInfo } from '@services/pomService';

const PomViewModal = ({ pomId, onClose }) => {
	const [pomInfo, setPomInfo] = useState(null);
	const [selectedImage, setSelectedImage] = useState([]);
	const scrollRef = useRef(null);

	useEffect(() => {
		onFetchData();
	}, []);

	const onFetchData = async () => {
		const data = await fetchPomInfo(pomId);
		setPomInfo(data);
	};

	const onSetCurrentImage = (item) => {
		const index = selectedImage.findIndex((image) => image.id === item.id);
		if (item.imageIndex >= 4) {
			if (scrollRef.current) {
				scrollRef.current.scrollBy({
					top: 100,
					behavior: 'smooth'
				});
			}
		}

		if (item.imageIndex <= 4) {
			if (scrollRef.current) {
				scrollRef.current.scrollBy({
					top: -100,
					behavior: 'smooth'
				});
			}
		}

		if (index !== -1) {
			const updatedSelectedImage = [...selectedImage];
			updatedSelectedImage[index] = item;
			setSelectedImage(updatedSelectedImage);
		} else {
			setSelectedImage([item]);
		}
	};

	const onGetCurrentImage = (id) => selectedImage?.find((image) => image?.id === id)?.imageIndex || 0;

	const NITEX_DATA = pomInfo?.brandDetailsResponseList?.find(
		(item) => item?.brandResponse?.name === 'NITEX'
	);

	return (
		<ModalContainer className="category-pom-modal">
			<div className="common-popup category-pom-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte d-flex align-items-center">
						<h3 className="semibold-16 mb-0">
							{pomInfo?.bodyPart?.name} . {NITEX_DATA?.pomCode}
						</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body product-slider-body shadow-1dp">
					<div className="product-slider-section scroll-y-label">
						<div className="product-information d-flex justify-content-between align-items-center">
							<div className="product-list d-flex">
								<div className="slider-nav d-flex flex-column">
									<div className="items scroll-y-label" ref={scrollRef}>
										{pomInfo?.visualResponseList?.map((item, idx) => (
											<div
												className={`cursor-pointer nav-single d-flex justify-content-center align-items-center ${
													onGetCurrentImage(pomInfo?.id) === idx ? 'active' : ''
												}`}
												key={item?.id}
												onClick={() => {
													setSelectedImage([{ id: pomInfo?.id, imageIndex: idx }]);
												}}
											>
												<img
													src={item?.documentResponse?.docUrl}
													width="60px"
													alt="product"
												/>
											</div>
										))}
									</div>
									<div className="slider-arrow">
										<span
											className="arrow top-arrow"
											onClick={() => {
												if (onGetCurrentImage(pomInfo?.id) !== 0) {
													onSetCurrentImage({
														id: pomInfo?.id,
														imageIndex: onGetCurrentImage(pomInfo?.id) - 1
													});
												}
											}}
										>
											<img src={`${process.env.PUBLIC_URL}/icons/angel-top.svg`} alt />
										</span>
										<span
											className="arrow bottom-arrow"
											onClick={() => {
												if (
													onGetCurrentImage(pomInfo?.id) <
													pomInfo?.visualResponseList?.length - 1
												) {
													onSetCurrentImage({
														id: pomInfo?.id,
														imageIndex: onGetCurrentImage(pomInfo?.id) + 1
													});
												}
											}}
										>
											<img
												src={`${process.env.PUBLIC_URL}/icons/angel-bottom.svg`}
												alt
											/>
										</span>
									</div>
								</div>
								<div className="pom-product-slider">
									{pomInfo?.visualResponseList[onGetCurrentImage(pomInfo?.id)]
										?.documentResponse?.docUrl && (
										<div className="product-single text-center">
											<img
												src={
													pomInfo?.visualResponseList[
														onGetCurrentImage(pomInfo?.id)
													]?.documentResponse?.docUrl
												}
												alt="product"
											/>
											<div className="pom-content">
												<p className="regular-12 gray_dark_01 weight-600">
													{
														pomInfo?.visualResponseList[
															onGetCurrentImage(pomInfo?.id)
														]?.name
													}
												</p>
												<p className="regular-12 gray_dark_02">
													{
														pomInfo?.visualResponseList[
															onGetCurrentImage(pomInfo?.id)
														]?.subCategoryName
													}
												</p>
											</div>
										</div>
									)}
								</div>
							</div>
							<div className="slider-info ml-3">
								<div className="product-description">
									<ul>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Body Part</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{' '}
												{pomInfo?.bodyPart?.name}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Nitex POM Code</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{' '}
												{NITEX_DATA?.pomCode}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">POM Name</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{NITEX_DATA?.pomName}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">How to measure</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{NITEX_DATA?.howToMeasure}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Tolerance</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{NITEX_DATA?.tolerance ? NITEX_DATA?.tolerance + ' CM' : ''}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Category</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{' '}
												{pomInfo?.allCategory
													? 'All'
													: pomInfo?.subCategoryResponseList
															?.map((category) => category?.name)
															.join(', ')}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Market</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{' '}
												{pomInfo?.allMarket
													? 'All'
													: pomInfo?.marketList
															?.map((market) => market?.name)
															.join(', ')}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">TBO</span>{' '}
											<span className="clone">:</span>
											{pomInfo?.parentCategory?.name}
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Position</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{pomInfo?.position?.name}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Serial</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{' '}
												{pomInfo?.serial}
											</span>
										</li>
										<li className="regular-12 d-flex justify-content-start">
											<span className="subtitle gray_dark_05">Side</span>
											<span className="clone">:</span>
											<span className="sub-info gray_dark_01 weight-500">
												{' '}
												{pomInfo?.side?.name}
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="pom-details-table pt-3 scroll-x-label">
							<h3 className="gray_dark_01 regular-14 weight-600">POM details for brands</h3>
							<table className="table with-border height-sm hover">
								<thead>
									<tr>
										<th className="weight-500">Brand</th>
										<th className="weight-500">POM Code &amp; POM</th>
										<th className="weight-500">How to Measure</th>
										<th className="weight-500">Tolerance</th>
									</tr>
								</thead>
								<tbody>
									{pomInfo?.brandDetailsResponseList?.reverse()?.map((item) => (
										<tr key={item?.id}>
											<td>{item?.brandResponse?.name}</td>
											<td>
												<span className="medium-14 gray_dark_01">
													{item?.pomCode}
												</span>{' '}
												<br />
												{item?.pomName}
											</td>
											<td>{item?.howToMeasure}</td>
											<td> {item?.tolerance ? item?.tolerance + ' CM' : ''}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default PomViewModal;
